import type { ReactNode } from "react";
import { DetailsAccordionItem } from "@design-system/Accordion/DetailsAccordionItem";
import { VStack } from "@design-system/VStack/VStack";

interface TemplateTaskWorkflowSectionProps {
    children: ReactNode;
}

export const TemplateTaskWorkflowSection = ({
    children,
}: TemplateTaskWorkflowSectionProps) => (
    <DetailsAccordionItem value="workflow" label="Action">
        <VStack gap={4}>{children}</VStack>
    </DetailsAccordionItem>
);
